(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("savvy", [], factory);
	else if(typeof exports === 'object')
		exports["savvy"] = factory();
	else
		root["savvy"] = factory();
})(global, function() {
return 